import type { InputHTMLAttributes } from 'react';

import { Typography } from '@remarkable/ark-web';

import { cn } from 'src/utils/classNamesHelper';

import { CopyButton } from './CopyButton';

export function CopyText(
  props: InputHTMLAttributes<HTMLButtonElement> & { value?: string }
) {
  return (
    <div
      className={cn(
        'rounded-sm flex items-center justify-between border border-neutral-light-8 py-8 pr-12 pl-16 ring-interaction-primary transition-all focus-within:border-interaction-primary focus-within:ring-1',
        props.className
      )}
    >
      <Typography variant="interface-md" className="leading-140">
        {props.value}
      </Typography>
      <CopyButton
        noText
        value={props.value}
        variant="tertiary-neutral"
        {...props}
        size="medium"
      />
    </div>
  );
}
